import { useMutation } from '@apollo/client';
import { UpdateInsightsWidgetDocument } from './UpdateInsightsWidget.gql';
export function useUpdateDashboardWidget() {
    const [mutate, state] = useMutation(UpdateInsightsWidgetDocument);
    const handler = (id, input) => mutate({
        variables: { id, input },
    });
    return [handler, state];
}
